// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-name[data-v-35499400]{height:28px;line-height:28px;color:#333}.go-table[data-v-35499400]{line-height:26px;text-align:center;display:inline-block;padding:0 5px;color:#333;border-radius:3px;border:1px solid #e2e2e2;margin-left:10px}", ""]);
// Exports
module.exports = exports;
